import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Accordion from '@mozaic-ds/freemarker/js/modules/_accordion.js';
var ServiceSolutionFamilyClass = /*#__PURE__*/function () {
  function ServiceSolutionFamilyClass() {
    _classCallCheck(this, ServiceSolutionFamilyClass);
    this.target = document.querySelector('.component-servicesolutionfamily');

    // Seo Zone
    if (document.querySelector('.js-zone-seo')) {
      this.seoZone = document.querySelector('.js-zone-seo');
      this.btnMoreChapter = this.seoZone.querySelector('.js-more-chapter');
      this.btnLessChapter = this.seoZone.querySelector('.js-less-chapter');
      this.seoChapters = this.seoZone.querySelector('.js-chapters');
      this.chaptersManager();
    }
    this.accordion();
  }
  return _createClass(ServiceSolutionFamilyClass, [{
    key: "accordion",
    value: function accordion() {
      var myAccordions = this.target.querySelectorAll('.js-accordion');
      if (myAccordions) {
        var _iterator = _createForOfIteratorHelper(myAccordions),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var myAccordion = _step.value;
            try {
              new Accordion(myAccordion);
            } catch (error) {
              console.error("error ".concat(error));
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }
  }, {
    key: "chaptersManager",
    value: function chaptersManager() {
      var _this = this;
      if (this.btnMoreChapter) {
        this.btnMoreChapter.addEventListener('click', function () {
          _this.loadMoreChapters();
        });
      }
      if (this.btnLessChapter) {
        this.btnLessChapter.addEventListener('click', function () {
          _this.loadLessChapters();
        });
      }
    }
  }, {
    key: "loadMoreChapters",
    value: function loadMoreChapters() {
      this.seoChapters.classList.remove('is-blurred');
      this.btnLessChapter.classList.remove('kl-hidden');
      this.btnMoreChapter.classList.add('kl-hidden');
    }
  }, {
    key: "loadLessChapters",
    value: function loadLessChapters() {
      this.seoChapters.classList.add('is-blurred');
      this.btnMoreChapter.classList.remove('kl-hidden');
      this.btnLessChapter.classList.add('kl-hidden');
      document.querySelector('.o-zone-seo').scrollIntoView();
    }
  }]);
}();
export default ServiceSolutionFamilyClass;